import { useStrapiUrl } from './useStrapiUrl.js';

export function useMediaHelpers() {
  const { getStrapiUrl } = useStrapiUrl();

  const isDirectVideoUrl = (videoDestination = '') => {
    return videoDestination.includes('/videos/') || /\.(mp4|webm|ogg|mov|m4v)(\?.*)?$/i.test(videoDestination);
  };

  const isAbsoluteUrl = (url = '') => /^(https?:)?\/\//i.test(url);

  const resolveVideoSrc = (videoDestination = '') => {
    if (!videoDestination) return '';
    return isAbsoluteUrl(videoDestination) ? videoDestination : getStrapiUrl(videoDestination);
  };

  const resolveImageUrl = (media = null) => {
    const directUrl = media?.url;
    const nestedUrl = media?.data?.attributes?.url;
    const value = directUrl || nestedUrl;

    if (!value) return '';
    return isAbsoluteUrl(value) ? value : getStrapiUrl(value);
  };

  const getWistiaEmbedUrl = (videoDestination = '') => {
    return `https://fast.wistia.net/embed/iframe/${videoDestination}?videoFoam=true&autoplay=false`;
  };

  return {
    isDirectVideoUrl,
    resolveVideoSrc,
    resolveImageUrl,
    getWistiaEmbedUrl,
  };
}
